import materaLakeside9_1 from "./3.png";
import materaLakeside9_2 from "./4.png";
import materaLakeside9_3 from "./5.png";
import materaLakeside9_4 from "./6.png";

const materaLakeside9 = [
  materaLakeside9_1,
  materaLakeside9_2,
  materaLakeside9_3,
  materaLakeside9_4,
];

export default materaLakeside9;
